import { createRouter, createWebHashHistory } from 'vue-router';
import TheDashBoard from '../components/dashboard/TheDashBoard.vue';
import TheLogin from '../components/authentication/TheLogin.vue';
import TheLogout from '../components/authentication/TheLogout.vue';
import ThePreloader from '../components/dashboard/ThePreloader.vue';
// import TheChangePersonalInfo from '../components/user/TheChangePersonalInfo.vue'
import TheChangePassword from '../components/authentication/TheChangePassword.vue';
import TheChangeInformation from '../components/authentication/TheChangeInformation.vue'
import TheLoggedInLayout from '../components/dashboard/TheLoggedInLayout.vue';

import TheTreeMenu from '@/components/dashboard/TheTreeMenu.vue';
// import TheLeafletMap2 from '../components/maps/TheLeafletMap2.vue'
// import TheLeafletMap3 from '../components/maps/TheLeafletMap3.vue'
import TheError404 from '../components/dashboard/TheError404.vue';
import { store } from '@/store';
import config from '@/config/prod.env';
import { authenticationService } from '@/services/authentication/authentication.service.js';
//Test
// import TestPdfViewer from '../components/TEST/TestPdfViewer.vue'

import TheMenu from '@/components/menu/TheMenu.vue'
import TheMenuRoleTree from '@/components/menu/TheMenuRoleTree.vue'
import ThePhanQuyenMenu from '@/components/menu/ThePhanQuyenMenu.vue'
//Danh muc
import TheDMLoaiDiaDiem from '@/components/danhmuc/dungchung/TheLoaiDiaDiem.vue'
import TheDMPhanLoaiDiaDiem from '@/components/danhmuc/dungchung/ThePhanLoaiDiaDiem.vue'
import TheDMNhomDanToc from '@/components/danhmuc/dungchung/TheNhomDanToc.vue'
import TheDMDanToc from '@/components/danhmuc/dungchung/TheDanToc.vue'
import TheDMTrinhDoChuyenMonY from '@/components/danhmuc/cosoyte/TheTrinhDoChuyenMonY.vue'
import TheDMTrinhDoChuyenMonCoSoDuoc from '@/components/danhmuc/cosoyte/TheTrinhDoChuyenMonCoSoDuoc.vue'
import TheDMLoaiHinhHanhNgheY from '@/components/danhmuc/cosoyte/TheLoaiHinhHanhNgheY.vue'
import TheDMHinhThucKinhDoanhCoSoDuoc from '@/components/danhmuc/cosoyte/TheHinhThucKinhDoanhCoSoDuoc.vue'
import TheDMChuyenKhoaY from '@/components/danhmuc/cosoyte/TheChuyenKhoaY.vue'
import TheDMTieuChuanKhachSan from '@/components/danhmuc/dichvuthietyeu/TheTieuChuanKhachSan.vue'
import TheDMLoaiDiTichVH from '@/components/danhmuc/vanhoa/TheLoaiDiTichVH.vue'
import TheDMLoaiHinhDiTichVH from '@/components/danhmuc/vanhoa/TheLoaiHinhDiTichVH.vue'
import TheDMBoMonTheThaoVH from '@/components/danhmuc/vanhoa/TheBoMonTheThaoVH.vue'
import TheDMHangCanTheThaoVH from '@/components/danhmuc/vanhoa/TheHangCanTheThaoVH.vue'
import TheDMPhamViGiaiTheThaoVH from '@/components/danhmuc/vanhoa/ThePhamViGiaiTheThaoVH.vue'
import TheDMNhomGiaiThiDauTheThaoVH from '@/components/danhmuc/vanhoa/TheNhomGiaiThiDauTheThaoVH.vue'
import TheDMNhomThanhTichTheThaoVH from '@/components/danhmuc/vanhoa/TheNhomThanhTichTheThaoVH.vue'
import TheDMCongTy from '@/components/danhmuc/dungchung/TheCongTy.vue'

//Co so y te
import TheBenhVien from '@/components/cosoyte/TheBenhVien.vue'
import TheCoSoDuoc from '@/components/cosoyte/TheCoSoDuoc.vue'
import TheCoSoYTeTuNhan from '@/components/cosoyte/TheCoSoYTeTuNhan.vue';
import TheTramYTe from '@/components/cosoyte/TheTramYTe.vue';

//Van hoa
import TheDiTichDiSanVH from '@/components/dulich/TheDiTichDiSan.vue'
import TheDiemDuLichVH from '@/components/dulich/TheDiemDuLich.vue'
import TheHoatDongDuLichVH from '@/components/dulich/TheHoatDongDuLich.vue'

import TheBaoLucGiaDinhVH from '@/components/vanhoa/TheBaoLucGiaDinh.vue'
import TheGiaDinhVanHoaVH from '@/components/vanhoa/TheGiaDinhVanHoa.vue'


import TheThanhTichTongHopTheThaoVH from '@/components/thethao/TheThanhTichTongHopTheThaoVH.vue'
import TheThanhTichTongHopTheThaoVH2 from '@/components/thethao/TheThanhTichTongHopTheThaoVH2.vue'

//TheThao
import TheThanhTichThiDauTheThaoVH from '@/components/thethao/TheThanhTichThiDauTheThao.vue'
import TheHuanLuyenVienTheThaoVH from '@/components/thethao/TheHuanLuyenVienTheThao.vue'
import TheVanDongVienTheThaoVH from '@/components/thethao/TheVanDongVienTheThao.vue'
import TheDoiTheThaoVH from '@/components/thethao/TheDoiTheThao.vue'
import TheThanhTichCaNhanTheThaoVH from '@/components/thethao/TheThanhTichCaNhanTheThao.vue'
import ThePhongTraoTheThaoVH from '@/components/thethao/ThePhongTraoTheThao.vue'
import TheTheThaoSuNghiep from '@/components/thethao/TheTheThaoSuNghiep.vue'
import TheDoiTheThaoThanhTich from '@/components/thethao/TheDoiTheThaoThanhTich.vue'
import TheGiaiThiDauTheThaoVH from '@/components/thethao/TheGiaiThiDauTheThao.vue'


//Co So Thiet Yeu
import TheDMNganHang from '@/components/danhmuc/dichvuthietyeu/TheNganHang.vue'
import TheATM from '@/components/dichvuthietyeu/TheATM.vue'
import TheKhachSan from '@/components/dichvuthietyeu/TheKhachSan.vue'
import TheTramXang from '@/components/dichvuthietyeu/TheTramXang.vue'
import TheNhaXe from '@/components/dichvuthietyeu/TheNhaXe.vue'
import TheBenXe from '@/components/dichvuthietyeu/TheBenXe.vue'
import TheDiemTienIch from '@/components/dichvuthietyeu/TheDiemTienIch.vue'
import TheDiemWifiCongCong from '@/components/dichvuthietyeu/TheDiemWifiCongCong.vue'
import TheNhaHang from '@/components/dichvuthietyeu/TheNhaHang.vue'

//GiaoDuc
import TheDMKyThiHSGGD from '@/components/danhmuc/giaoduc/TheKyThiHSG.vue'
import TheDMThanhTichHSGGD from '@/components/danhmuc/giaoduc/TheThanhTichHSG.vue'
import TheDMMonHocGD from '@/components/danhmuc/giaoduc/TheMonHoc.vue'
import TheDMMucTruongChuanGD from '@/components/danhmuc/giaoduc/TheMucTruongChuan.vue'
import TheDMQuyMoTruongChuanGD from '@/components/danhmuc/giaoduc/TheQuyMoTruongChuan.vue'
import TheDMPhanLoaiTruongGD from '@/components/danhmuc/giaoduc/ThePhanLoaiTruong.vue'
import TheDMPhanLoaiTruongMamNonGD from '@/components/danhmuc/giaoduc/ThePhanLoaiTruongMamNon.vue'
import TheDMLoaiHinhTruongMamNonGD from '@/components/danhmuc/giaoduc/TheLoaiHinhTruongMamNon.vue'
import TheTruongQGGD from '@/components/giaoduc/caphockhac/TheTruongQGGD.vue'
import TheTruongQGGD2 from '@/components/giaoduc/caphockhac/TheTruongQGGD2.vue'
import TheHocSinhGioiGD from '@/components/giaoduc/TheHocSinhGioiGD.vue'
import TheTruongLopHoc from '@/components/giaoduc/caphockhac/TheTruong_LopHoc.vue'
import TheTruongPhongHoc from '@/components/giaoduc/caphockhac/TheTruong_PhongHoc.vue'
import TheTruongGiaoVien from '@/components/giaoduc/caphockhac/TheTruong_GiaoVien.vue'
import TheTruongHocSinh from '@/components/giaoduc/caphockhac/TheTruong_HocSinh.vue'
import TheTruongMamNonGD2 from '@/components/giaoduc/mamnon/TheTruongMamNonGD2.vue'
import TheTruongMamNonLopHoc from '@/components/giaoduc/mamnon/TheTruongMamNon_LopHoc.vue'
import TheTruongMamNonPhongHoc from '@/components/giaoduc/mamnon/TheTruongMamNon_PhongHoc.vue'
import TheTruongMamNonGiaoVien from '@/components/giaoduc/mamnon/TheTruongMamNon_GiaoVien.vue'
import TheTruongMamNonHocSinh from '@/components/giaoduc/mamnon/TheTruongMamNon_HocSinh.vue'
import TheBaoCaoGD from '@/components/giaoduc/TheBaoCaoGD.vue'

//HeThongChieuSang
import TheDMLoaiTruDen from '@/components/danhmuc/hethongchieusang/TheLoaiTruDen.vue'
import TheDMLoaiDen from '@/components/danhmuc/hethongchieusang/TheLoaiDen.vue'

import TheDMCongSuatDen from '@/components/danhmuc/hethongchieusang/TheCongSuatDen.vue'
import TheDMTinhTrangDen from '@/components/danhmuc/hethongchieusang/TheTinhTrangDen.vue'
import TheDMTinhTrangTruDen from '@/components/danhmuc/hethongchieusang/TheTinhTrangTruDen.vue'
import TheDMLoaiTuyenDuong from '@/components/danhmuc/hethongchieusang/TheLoaiTuyenDuong.vue'
import TheTuyenDenDuong from '@/components/hethongchieusang/TheTuyenDenDuong.vue'
import TheTruDenChieuSang from '@/components/hethongchieusang/TheTruDenChieuSang.vue'
import TheTruDenGiaoThong from '@/components/hethongchieusang/TheTruDenGiaoThong.vue'
import TheSuaChuaTruDenChieuSang from '@/components/hethongchieusang/TheSuaChuaTruDenChieuSang.vue'

//TaiChinhKeHoach
import TheDMTienDoDauTu from '@/components/danhmuc/taichinhkehoach/TheTienDoDauTu.vue'
import TheThuChiNganSach from '@/components/taichinhkehoach/TheThuChiNganSach.vue'
import TheNguonVonDauTu from '@/components/taichinhkehoach/TheNguonVonDauTu.vue'
import TheDuAnDauTu from '@/components/taichinhkehoach/TheDuAnDauTu.vue'
import TheKeHoachVon from '@/components/taichinhkehoach/TheKeHoachVon'
import TheTienDoGiaiNgan from '@/components/taichinhkehoach/TheTienDoGiaiNgan'     
import TheBaoCaoKeHoachVon from '@/components/taichinhkehoach/TheBaoCaoKeHoachVon.vue'
import TheBaoCaoKTXH from '@/components/taichinhkehoach/TheBaoCaoKTXH.vue'

//XuLyRacThai
import TheDMLoaiTuyenDuongQuetRac from '@/components/danhmuc/xulyracthai/TheLoaiTuyenDuongQuetRac.vue'
import TheDMTuyenDuongThuGomRac from '@/components/danhmuc/xulyracthai/TheTuyenDuongThuGomRac.vue'
import TheDiaBanThuGomRac from '@/components/danhmuc/xulyracthai/TheDiaBanThuGomRac.vue'
import TheLichQuetRac from '@/components/xulyracthai/TheLichQuetRac'
import TheLichThuGomRac from '@/components/xulyracthai/TheLichThuGomRac.vue'
import TheLichNaoVetHoGa from '@/components/xulyracthai/TheLichNaoVetHoGa.vue'
import TheLichVeSinhDoThiKhac from '@/components/xulyracthai/TheLichVeSinhDoThiKhac.vue'

const routes = [
	{
		path: '/:pathMatch(.*)*',
		name: 'TheError404',
		component: TheError404
	},
	// {
	// 	path: '/login',
	// 	name: 'TheLogin',
	// 	component: TheLogin,
	// 	props: true,
	// 	meta: {
	// 		authRequired: false,
	// 	},
	// },



	{
		path: '/logout',
		name: 'TheLogout',
		component: TheLogout,
		props: true,
		meta: {
			authRequired: false,
		},
	},
	{
		path: '/preloader',
		name: 'ThePreloader',
		component: ThePreloader,
		props: true,
		meta: {
			authRequired: true,
		},
	},
	{
		path: '/',
		name: 'TheLoggedInLayout',
		component: TheLoggedInLayout,
		props: true,
		meta: {
			authRequired: true,
		},
		children: [
			{
				path: '/changepassword',
				name: 'TheChangePassword',
				component: TheChangePassword,
				props: true,
				meta: {
					authRequired: true,
				}
			},
			{
				path: '/changepersonalinfo',
				name: 'TheChangeInformation',
				component: TheChangeInformation,
				props: true,
				meta: {
					authRequired: true,
				}
			},
			{
				path: '/treemenu',
				name: 'TheTreeMenu',
				component: TheTreeMenu,
				props: true,
				meta: {
					authRequired: true,
				}
			},
			{
				path: '/dashboard',
				name: 'TheDashBoard',
				component: TheDashBoard,
				props: true,
				meta: {
					authRequired: true,
				},
			},
			{
				path: '/quantri/menu',
				name: 'TheMenu',
				component: TheMenu,
				props: true,
				meta: {
					authRequired: true,
				},
			},
			{
				path: '/quantri/phanquyenmenu/:id',
				name: 'TheMenuRoleTree',
				component: TheMenuRoleTree,
				props: true,
				meta: {
					authRequired: true,
				},
			},

			{
				path: '/quantri/phanquyenmenu',
				name: 'ThePhanQuyenMenu',
				component: ThePhanQuyenMenu,
				props: true,
				meta: {
					authRequired: true,
				},
			},
			// Cau hinh danh muc
			{
				path: '/danhmuc/loaidiadiem',
				name: 'TheDMLoaiDiaDiem',
				component: TheDMLoaiDiaDiem,
				props: true,
				meta: {
					authRequired: true,
				}
			},
			{
				path: '/danhmuc/phanloaidiadiem',
				name: 'TheDMPhanLoaiDiaDiem',
				component: TheDMPhanLoaiDiaDiem,
				props: true,
				meta: {
					authRequired: true,
				}
			},
			{
				path: '/danhmuc/nhomdantoc',
				name: 'TheDMNhomDanToc',
				component: TheDMNhomDanToc,
				props: true,
				meta: {
					authRequired: true,
				}
			},
			{
				path: '/danhmuc/dantoc',
				name: 'TheDMDanToc',
				component: TheDMDanToc,
				props: true,
				meta: {
					authRequired: true,
				}
			},
			{
				path: '/danhmuc/trinhdochuyenmony',
				name: 'TheDMTrinhDoChuyenMonY',
				component: TheDMTrinhDoChuyenMonY,
				props: true,
				meta: {
					authRequired: true,
				}
			},
			{
				path: '/danhmuc/trinhdochuyenmoncosoduoc',
				name: 'TheDMTrinhDoChuyenMonCoSoDuoc',
				component: TheDMTrinhDoChuyenMonCoSoDuoc,
				props: true,
				meta: {
					authRequired: true,
				}
			},
			{
				path: '/danhmuc/loaihinhhanhnghey',
				name: 'TheDMLoaiHinhHanhNgheY',
				component: TheDMLoaiHinhHanhNgheY,
				props: true,
				meta: {
					authRequired: true,
				}
			},
			{
				path: '/danhmuc/hinhthuckinhdoanhcosoduoc',
				name: 'TheDMHinhThucKinhDoanhCoSoDuoc',
				component: TheDMHinhThucKinhDoanhCoSoDuoc,
				props: true,
				meta: {
					authRequired: true,
				}
			},
			{
				path: '/danhmuc/chuyenkhoay',
				name: 'TheDMChuyenKhoaY',
				component: TheDMChuyenKhoaY,
				props: true,
				meta: {
					authRequired: true,
				}
			},
			{
				path: '/danhmuc/tieuchuankhachsan',
				name: 'TheDMTieuChuanKhachSan',
				component: TheDMTieuChuanKhachSan,
				props: true,
				meta: {
					authRequired: true,
				}
			},
			{
				path: '/danhmuc/tieuchuankhachsan',
				name: 'TheDMTieuChuanKhachSan',
				component: TheDMTieuChuanKhachSan,
				props: true,
				meta: {
					authRequired: true,
				}
			},
			{
				path: '/danhmuc/nganhang',
				name: 'TheDMNganHang',
				component: TheDMNganHang,
				props: true,
				meta: {
					authRequired: true,
				}
			},

			{
				path: '/dichvuthietyeu/atm',
				name: 'TheATM',
				component: TheATM,
				props: true,
				meta: {
					authRequired: true,
				}
			},

			{
				path: '/dichvuthietyeu/khachsan',
				name: 'TheKhachSan',
				component: TheKhachSan,
				props: true,
				meta: {
					authRequired: true,
				}
			},
			{
				path: '/dichvuthietyeu/tramxang',
				name: 'TheTramXang',
				component: TheTramXang,
				props: true,
				meta: {
					authRequired: true,
				}
			},

			{
				path: '/dichvuthietyeu/nhaxe',
				name: 'TheNhaXe',
				component: TheNhaXe,
				props: true,
				meta: {
					authRequired: true,
				}
			},

			{
				path: '/dichvuthietyeu/benxe',
				name: 'TheBenXe',
				component: TheBenXe,
				props: true,
				meta: {
					authRequired: true,
				}
			},

			{
				path: '/dichvuthietyeu/diemtienich',
				name: 'TheDiemTienIch',
				component: TheDiemTienIch,
				props: true,
				meta: {
					authRequired: true,
				}
			},

			{
				path: '/dichvuthietyeu/diemwificongcong',
				name: 'TheDiemWifiCongCong',
				component: TheDiemWifiCongCong,
				props: true,
				meta: {
					authRequired: true,
				}
			},

			{
				path: '/dichvuthietyeu/nhahang',
				name: 'TheNhaHang',
				component: TheNhaHang,
				props: true,
				meta: {
					authRequired: true,
				}
			},

			{
				path: '/danhmuc/monhocgd',
				name: 'TheDMMonHocGD',
				component: TheDMMonHocGD,
				props: true,
				meta: {
					authRequired: true,
				}
			},
			{
				path: '/danhmuc/muctruongchuangd',
				name: 'TheDMMucTruongChuanGD',
				component: TheDMMucTruongChuanGD,
				props: true,
				meta: {
					authRequired: true,
				}
			},
			{
				path: '/danhmuc/quymotruongchuangd',
				name: 'TheDMQuyMoTruongChuanGD',
				component: TheDMQuyMoTruongChuanGD,
				props: true,
				meta: {
					authRequired: true,
				}
			},
			{
				path: '/danhmuc/kythihsggd',
				name: 'TheDMKyThiHSGGD',
				component: TheDMKyThiHSGGD,
				props: true,
				meta: {
					authRequired: true,
				}
			},
			{
				path: '/danhmuc/thanhtichhsggd',
				name: 'TheDMThanhTichHSGGD',
				component: TheDMThanhTichHSGGD,
				props: true,
				meta: {
					authRequired: true,
				}
			},
			{
				path: '/danhmuc/phanloaitruong',
				name: 'TheDMPhanLoaiTruongGD',
				component: TheDMPhanLoaiTruongGD,
				props: true,
				meta: {
					authRequired: true,
				}
			},
			{
				path: '/danhmuc/phanloaitruongmamnon',
				name: 'TheDMPhanLoaiTruongMamNonGD',
				component: TheDMPhanLoaiTruongMamNonGD,
				props: true,
				meta: {
					authRequired: true,
				}
			},
			{
				path: '/danhmuc/loaihinhtruongmamnon',
				name: 'TheDMLoaiHinhTruongMamNonGD',
				component: TheDMLoaiHinhTruongMamNonGD,
				props: true,
				meta: {
					authRequired: true,
				}
			},
			// {
			// 	path: '/giaoduc/truongQGGD',
			// 	name: 'TheTruongQGGD',
			// 	component: TheTruongQGGD,
			// 	props: true,
			// 	meta: {
			// 		authRequired: true,
			// 	}
			// },
			{
				path: '/giaoduc/truongQGGD',
				name: 'TheTruongQGGD2',
				component: TheTruongQGGD2,
				props: true,
				meta: {
					authRequired: true,
				}
			},


			// {
			// 	path: '/giaoduc/truongmamnon',
			// 	name: 'TheTruongMamNonGD',
			// 	component: TheTruongMamNonGD,
			// 	props: true,
			// 	meta: {
			// 		authRequired: true,
			// 	}
			// },
			{
				path: '/giaoduc/truongmamnon',
				name: 'TheTruongMamNonGD2',
				component: TheTruongMamNonGD2,
				props: true,
				meta: {
					authRequired: true,
				}
			},
			{
				path: '/giaoduc/hocsinhgioigd',
				name: 'TheHocSinhGioiGD',
				component: TheHocSinhGioiGD,
				props: true,
				meta: {
					authRequired: true,
				}
			},

			{
				path: '/giaoduc/truonglophoc',
				name: 'TheTruongLopHoc',
				component: TheTruongLopHoc,
				props: true,
				meta: {
					authRequired: true,
				}
			},
			{
				path: '/giaoduc/truongphonghoc',
				name: 'TheTruongPhongHoc',
				component: TheTruongPhongHoc,
				props: true,
				meta: {
					authRequired: true,
				}
			},

			{
				path: '/giaoduc/truonggiaovien',
				name: 'TheTruongGiaoVien',
				component: TheTruongGiaoVien,
				props: true,
				meta: {
					authRequired: true,
				}
			},

			{
				path: '/giaoduc/truonghocsinh',
				name: 'TheTruongHocSinh',
				component: TheTruongHocSinh,
				props: true,
				meta: {
					authRequired: true,
				}
			},

			{
				path: '/giaoduc/truongmamnonlophoc',
				name: 'TheTruongMamNonLopHoc',
				component: TheTruongMamNonLopHoc,
				props: true,
				meta: {
					authRequired: true,
				}
			},

			{
				path: '/giaoduc/truongmamnonphonghoc',
				name: 'TheTruongMamNonPhongHoc',
				component: TheTruongMamNonPhongHoc,
				props: true,
				meta: {
					authRequired: true,
				}
			},

			{
				path: '/giaoduc/truongmamnongiaovien',
				name: 'TheTruongMamNonGiaoVien',
				component: TheTruongMamNonGiaoVien,
				props: true,
				meta: {
					authRequired: true,
				}
			},

			{
				path: '/giaoduc/truongmamnonhocsinh',
				name: 'TheTruongMamNonHocSinh',
				component: TheTruongMamNonHocSinh,
				props: true,
				meta: {
					authRequired: true,
				}
			},

			{
				path: '/giaoduc/baoCaoGD',
				name: 'TheBaoCaoGD',
				component: TheBaoCaoGD,
				props: true,
				meta: {
					authRequired: true,
				}
			},

			{
				path: '/danhmuc/loaiditichvh',
				name: 'TheDMLoaiDiTichVH',
				component: TheDMLoaiDiTichVH,
				props: true,
				meta: {
					authRequired: true,
				}
			},

			{
				path: '/danhmuc/loaihinhditichvh',
				name: 'TheDMLoaiHinhDiTichVH',
				component: TheDMLoaiHinhDiTichVH,
				props: true,
				meta: {
					authRequired: true,
				}
			},

			{
				path: '/danhmuc/bomonthethaovh',
				name: 'TheDMBoMonTheThaoVH',
				component: TheDMBoMonTheThaoVH,
				props: true,
				meta: {
					authRequired: true,
				}
			},

			{
				path: '/danhmuc/hangcanthethaovh',
				name: 'TheDMHangCanTheThaoVH',
				component: TheDMHangCanTheThaoVH,
				props: true,
				meta: {
					authRequired: true,
				}
			},

			{
				path: '/danhmuc/phamvigiaithethaovh',
				name: 'TheDMPhamViGiaiTheThaoVH',
				component: TheDMPhamViGiaiTheThaoVH,
				props: true,
				meta: {
					authRequired: true,
				}
			},

			{
				path: '/danhmuc/nhomgiaithethaovh',
				name: 'TheDMNhomGiaiThiDauTheThaoVH',
				component: TheDMNhomGiaiThiDauTheThaoVH,
				props: true,
				meta: {
					authRequired: true,
				}
			},


			{
				path: '/danhmuc/nhomthanhtichthethaovh',
				name: 'TheDMNhomThanhTichTheThaoVH',
				component: TheDMNhomThanhTichTheThaoVH,
				props: true,
				meta: {
					authRequired: true,
				}
			},

			{
				path: '/danhmuc/congty',
				name: 'TheDMCongTy',
				component: TheDMCongTy,
				props: true,
				meta: {
					authRequired: true,
				}
			},

			{
				path: '/vanhoa/ditichdisanvh',
				name: 'TheDiTichDiSanVH',
				component: TheDiTichDiSanVH,
				props: true,
				meta: {
					authRequired: true,
				}
			},
			{
				path: '/vanhoa/diemdulich',
				name: 'TheDiemDuLichVH',
				component: TheDiemDuLichVH,
				props: true,
				meta: {
					authRequired: true,
				}
			},

			{
				path: '/vanhoa/giaithidauthethao',
				name: 'TheGiaiThiDauTheThaoVH',
				component: TheGiaiThiDauTheThaoVH,
				props: true,
				meta: {
					authRequired: true,
				}
			},

			{
				path: '/vanhoa/thanhtichdauthethao',
				name: 'TheThanhTichThiDauTheThaoVH',
				component: TheThanhTichThiDauTheThaoVH,
				props: true,
				meta: {
					authRequired: true,
				}
			},

			{
				path: '/vanhoa/huanluyenvienthethao',
				name: 'TheHuanLuyenVienTheThaoVH',
				component: TheHuanLuyenVienTheThaoVH,
				props: true,
				meta: {
					authRequired: true,
				}
			},

			{
				path: '/vanhoa/vandongvienthethao',
				name: 'TheVanDongVienTheThaoVH',
				component: TheVanDongVienTheThaoVH,
				props: true,
				meta: {
					authRequired: true,
				}
			},

			{
				path: '/vanhoa/thanhtichcanhanthethao',
				name: 'TheThanhTichCaNhanTheThaoVH',
				component: TheThanhTichCaNhanTheThaoVH,
				props: true,
				meta: {
					authRequired: true,
				}
			},

			{
				path: '/vanhoa/doithethao',
				name: 'TheDoiTheThaoVH',
				component: TheDoiTheThaoVH,
				props: true,
				meta: {
					authRequired: true,
				}
			},
			{
				path: '/vanhoa/doithethaothanhtich',
				name: 'TheDoiTheThaoThanhTich',
				component: TheDoiTheThaoThanhTich,
				props: true,
				meta: {
					authRequired: true,
				}
			},

			{
				path: '/vanhoa/thanhtichtonghopthethao',
				name: 'TheThanhTichTongHopTheThaoVH',
				component: TheThanhTichTongHopTheThaoVH,
				props: true,
				meta: {
					authRequired: true,
				}
			},

			{
				path: '/vanhoa/thanhtichtonghopthethao2',
				name: 'TheThanhTichTongHopTheThaoVH2',
				component: TheThanhTichTongHopTheThaoVH2,
				props: true,
				meta: {
					authRequired: true,
				}
			},

			{
				path: '/vanhoa/sunghiepthethao',
				name: 'TheTheThaoSuNghiep',
				component: TheTheThaoSuNghiep,
				props: true,
				meta: {
					authRequired: true,
				}
			},

			{
				path: '/vanhoa/phongtraothethao',
				name: 'ThePhongTraoTheThaoVH',
				component: ThePhongTraoTheThaoVH,
				props: true,
				meta: {
					authRequired: true,
				}
			},

			{
				path: '/vanhoa/hoatdongdulich',
				name: 'TheHoatDongDuLichVH',
				component: TheHoatDongDuLichVH,
				props: true,
				meta: {
					authRequired: true,
				}
			},

			{
				path: '/vanhoa/baolucgiadinh',
				name: 'TheBaoLucGiaDinhVH',
				component: TheBaoLucGiaDinhVH,
				props: true,
				meta: {
					authRequired: true,
				}
			},

			{
				path: '/vanhoa/giadinhvanhoa',
				name: 'TheGiaDinhVanHoaVH',
				component: TheGiaDinhVanHoaVH,
				props: true,
				meta: {
					authRequired: true,
				}
			},
			//Co so y te
			{
				path: '/cosoyte/benhvien',
				name: 'TheBenhVien',
				component: TheBenhVien,
				props: true,
				meta: {
					authRequired: true,
				}
			},
			{
				path: '/cosoyte/cosoduoc',
				name: 'TheCoSoDuoc',
				component: TheCoSoDuoc,
				props: true,
				meta: {
					authRequired: true,
				}
			},
			{
				path: '/cosoyte/cosoytetunhan',
				name: 'TheCoSoYTeTuNhan',
				component: TheCoSoYTeTuNhan,
				props: true,
				meta: {
					authRequired: true,
				}
			},
			{
				path: '/cosoyte/tramyte',
				name: 'TheTramYTe',
				component: TheTramYTe,
				props: true,
				meta: {
					authRequired: true,
				}
			},

			// He Thong Chieu Sang
			{
				path: '/danhmuc/loaitruden',
				name: 'TheDMLoaiTruDen',
				component: TheDMLoaiTruDen,
				props: true,
				meta: {
					authRequired: true,
				}
			},
			{
				path: '/danhmuc/loaiden',
				name: 'TheDMLoaiDen',
				component: TheDMLoaiDen,
				props: true,
				meta: {
					authRequired: true,
				}
			},
			{
				path: '/danhmuc/congsuatden',
				name: 'TheDMCongSuatDen',
				component: TheDMCongSuatDen,
				props: true,
				meta: {
					authRequired: true,
				}
			},
			{
				path: '/danhmuc/tinhtrangden',
				name: 'TheDMTinhTrangDen',
				component: TheDMTinhTrangDen,
				props: true,
				meta: {
					authRequired: true,
				}
			},
			{
				path: '/danhmuc/tinhtrangtruden',
				name: 'TheDMTinhTrangTruDen',
				component: TheDMTinhTrangTruDen,
				props: true,
				meta: {
					authRequired: true,
				}
			},
			{
				path: '/danhmuc/loaituyenduong',
				name: 'TheDMLoaiTuyenDuong',
				component: TheDMLoaiTuyenDuong,
				props: true,
				meta: {
					authRequired: true,
				}
			},

			{
				path: '/hethongchieusang/tuyendenduong',
				name: 'TheTuyenDenDuong',
				component: TheTuyenDenDuong,
				props: true,
				meta: {
					authRequired: true,
				}
			},

			{
				path: '/hethongchieusang/trudenchieusang',
				name: 'TheTruDenChieuSang',
				component: TheTruDenChieuSang,
				props: true,
				meta: {
					authRequired: true,
				}
			},

			{
				path: '/hethongchieusang/trudengiaothong',
				name: 'TheTruDenGiaoThong',
				component: TheTruDenGiaoThong,
				props: true,
				meta: {
					authRequired: true,
				}
			},

			{
				path: '/hethongchieusang/suachuatrudenchieusang',
				name: 'TheSuaChuaTruDenChieuSang',
				component: TheSuaChuaTruDenChieuSang,
				props: true,
				meta: {
					authRequired: true,
				}
			},



			// Tai chinh Ke hoach
			{
				path: '/taichinhkehoach/thuchingansach',
				name: 'TheThuChiNganSach',
				component: TheThuChiNganSach,
				props: true,
				meta: {
					authRequired: true,
				}
			},

			{
				path: '/taichinhkehoach/nguonvondautu',
				name: 'TheNguonVonDauTu',
				component: TheNguonVonDauTu,
				props: true,
				meta: {
					authRequired: true,
				}
			},

			{
				path: '/danhmuc/tiendodautu',
				name: 'TheDMTienDoDauTu',
				component: TheDMTienDoDauTu,
				props: true,
				meta: {
					authRequired: true,
				}
			},

			{
				path: '/taichinhkehoach/kehoachvon',
				name: 'TheKeHoachVon',
				component: TheKeHoachVon,
				props: true,
				meta: {
					authRequired: true,
				}
			},

			{
				path: '/taichinhkehoach/tiendogiaingan',
				name: 'TheTienDoGiaiNgan',
				component: TheTienDoGiaiNgan,
				props: true,
				meta: {
					authRequired: true,
				}
			},

			{
				path: '/taichinhkehoach/duandautu',
				name: 'TheDuAnDauTu',
				component: TheDuAnDauTu,
				props: true,
				meta: {
					authRequired: true,
				}
			},

			{
				path: '/taichinhkehoach/baocaokehoachvon',
				name: 'TheBaoCaoKeHoachVon',
				component: TheBaoCaoKeHoachVon,
				props: true,
				meta: {
					authRequired: true,
				}
			},

			{
				path: '/taichinhkehoach/baocaoktxh',
				name: 'TheBaoCaoKTXH',
				component: TheBaoCaoKTXH,
				props: true,
				meta: {
					authRequired: true,
				}
			},

			// Xu Ly Rac Thai
			{
				path: '/danhmuc/loaituyenduongquetrac',
				name: 'TheDMLoaiTuyenDuongQuetRac',
				component: TheDMLoaiTuyenDuongQuetRac,
				props: true,
				meta: {
					authRequired: true,
				}
			},

			{
				path: '/danhmuc/tuyenduongthugomrac',
				name: 'TheDMTuyenDuongThuGomRac',
				component: TheDMTuyenDuongThuGomRac,
				props: true,
				meta: {
					authRequired: true,
				}
			},

			{
				path: '/danhmuc/diabanthugomrac',
				name: 'TheDiaBanThuGomRac',
				component: TheDiaBanThuGomRac,
				props: true,
				meta: {
					authRequired: true,
				}
			},

			{
				path: '/xulyracthai/lichquetrac',
				name: 'TheLichQuetRac',
				component: TheLichQuetRac,
				props: true,
				meta: {
					authRequired: true,
				}
			},

			{
				path: '/xulyracthai/lichthugomrac',
				name: 'TheLichThuGomRac',
				component: TheLichThuGomRac,
				props: true,
				meta: {
					authRequired: true,
				}
			},

			{
				path: '/xulyracthai/lichnaovethoga',
				name: 'TheLichNaoVetHoGa',
				component: TheLichNaoVetHoGa,
				props: true,
				meta: {
					authRequired: true,
				}
			},

			{
				path: '/xulyracthai/lichvesinhdothikhac',
				name: 'TheLichVeSinhDoThiKhac',
				component: TheLichVeSinhDoThiKhac,
				props: true,
				meta: {
					authRequired: true,
				}
			},
		],
	},
];

const router = createRouter({
	history: createWebHashHistory(),
	routes
})

router.beforeEach(async (to, from, next) => {

	let loginId = to.query.login;
	if (loginId) {
		let res = await authenticationService.getLoginInfoFromSSO(loginId, config.APPID)
		if (res.code) {
			next('/dashboard');
		}
		else{
			window.location.href = `${config.LOGIN_PAGE}#/login?appId=${config.APPID}`;
		}

	}
	else {
		let loggedIn = store.state.authentication.status.loggedIn;
		let user = JSON.parse(localStorage.getItem('user'));
		if (user && Date.parse(user.expiresTime) > Date.now()) {
			//Con han dang nhap va co dang nhap
			loggedIn = true;
		}
		else {
			loggedIn = false;
			// if (user && Date.parse(user.expiresTime) <= Date.now()) {
			// 	loggedIn = true;
			// }
			// else {
			// 	loggedIn = user && Date.parse(user.expiresTime) > Date.now() ? true : false;
			// }
		}
		let authPage = to.meta.authRequired;
		if (authPage && !loggedIn) {
			localStorage.removeItem('user');
			localStorage.removeItem('menu');
			//next('/login');
			window.location.href = `${config.LOGIN_PAGE}#/login?appId=${config.APPID}`;
		}
		else {
			next();
		}
	}


});

export default router;
